const TOPICS_LIST = [
  {
    title: '热血少年漫精选',
    desc: '从《海贼王》到《咒术回战》，最燃战斗一次看过瘾',
    count: '2,300+ 部',
    icon: 'ri-fire-line',
  },
  {
    title: '恋爱少女漫合集',
    desc: '甜蜜心动，治愈日常，少女漫画一网打尽',
    count: '1,800+ 部',
    icon: 'ri-heart-pulse-line',
  },
  {
    title: '悬疑推理专区',
    desc: '烧脑剧情，层层反转，悬疑漫画爱好者聚集地',
    count: '950+ 部',
    icon: 'ri-search-eye-line',
  },
  {
    title: '奇幻冒险专题',
    desc: '异世界穿越、剑与魔法，奇幻题材大全',
    count: '1,600+ 部',
    icon: 'ri-compass-discover-line',
  },
  {
    title: '搞笑日常推荐',
    desc: '轻松一刻，欢乐治愈，搞笑漫画每日更新',
    count: '1,200+ 部',
    icon: 'ri-emotion-laugh-line',
  },
  {
    title: '经典名作回顾',
    desc: '重温那些年追过的经典漫画，每一页都是回忆',
    count: '800+ 部',
    icon: 'ri-bookmark-line',
  },
  {
    title: '新番速递频道',
    desc: '最新连载第一时间同步，追番快人一步',
    count: '每日更新',
    icon: 'ri-rocket-line',
  },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-10">
          <div className="w-10 h-10 rounded-xl bg-accent-100 flex items-center justify-center">
            <i className="ri-grid-line text-accent-600 text-xl"></i>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">热门专题</h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          {TOPICS_LIST.slice(0, 7).map((item, i) => (
            <a
              key={i}
              href="#cards"
              className="group flex items-start gap-4 p-5 bg-background-50 border border-background-200 rounded-xl hover:border-primary-300 hover:bg-primary-50/30 transition-all duration-200 cursor-pointer"
            >
              <div className="w-10 h-10 rounded-xl bg-accent-100 flex items-center justify-center flex-shrink-0 group-hover:bg-primary-100 transition-colors">
                <i className={`${item.icon} text-accent-600 group-hover:text-primary-600 text-lg transition-colors`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-semibold text-sm text-foreground-800 mb-1 whitespace-nowrap overflow-hidden text-ellipsis">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed mb-2 line-clamp-2">{item.desc}</p>
                <span className="text-xs font-medium text-primary-600">{item.count}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}